import BaseRouter from 'scoreboard/components/base-router'
import appDisplay from 'scoreboard/components/app-display'
import Buttons from './test-buttons-view'
import Toggles from './test-toggles-view'
import Inputs from './test-inputs-view'
import ViewIconsView from './view-icons-view'
import ComponentIconTest from './component-icon-test'
import reportDesignerTable from './report-table.hbs'
import emptyReportTable from './empty-report-table.hbs'
import ProgressIndicatorsTestView from './progress-indicators-test-view'
import TextLinksBadgesView from './text-link-badges-view'
import CalendarsView from './test-calendars-view'
import TooltipsBannersView from './tooltips-banners-view'
import MiscComponentsView from './misc-components'
import PanelsListsTables from './panels-lists-tables'
import TreesView from './test-trees-view'
import TwoColumnExpandView from './test-two-column-details-view'
import testMenu from './test-menu.hbs'
import LoadingPageView from './loading-page-view'
import EmptyStateView from './empty-state-view'
import Nav from 'scoreboard/admin/admin-nav'
import DialogTest from './dialog-test'
import DashboardWidgetsView from './dashboard-widgets-view'
import ColorsTestView from './test-colors-view'
import LogicianExamplesView from './logician-examples-view'
import DashboardAIAssistantTestView from './dashboard-ai-assistant-test-view'
import ConjunctionEditorExamplesView from './conjunction-editor-examples-view'

var TestRouter = BaseRouter.extend({

	routes: {
		'test/all(/)': 'allTests',
		'test/colors': 'colors',
		'test/view-icons(/)': 'viewIcons',
		'test/component-icon-test(/)': 'componentIconTest',
		'test/buttons(/)': 'buttons',
		'test/inputs(/)': 'inputs',
		'test/toggles(/)': 'toggles',
		'test/progress-indicators(/)': 'progressIndicators',
		'test/text-links-badges(/)': 'textLinksBadges',
		'test/calendars(/)': 'calendars',
		'test/tooltips-banners(/)': 'tooltipsBanners',
		'test/panels-lists-tables(/)': 'panelsListsTables',
		'test/trees(/)': 'trees',
		'test/two-column-expand(/)': 'twoColumnExpand',
		'test/loading-page(/)': 'loadingPage',
		'test/empty-state/(:view)(/)': 'emptyState',
		'test/dialogs(/)': 'dialog',
		'test/dashboard-widgets(/)':'dashboardWidgets',
		'test/misc-components(/)': 'miscComponents',
		'test/report-table(/)': 'reportDesignerTable',
		'test/empty-report-table(/)': 'emptyReportTable',
		'test/conjunction-editor(/)': 'conjunctionEditor',
		'test/logician(/)': 'logician',
		'test/dashboard-ai-assistant(/)': 'dashboardAIAssistant'
	},

	Nav: Nav,

	// highlight the test-pages link in the nav pane for all results
	execute: function() {
		var result = BaseRouter.prototype.execute.apply(this, arguments)
		this.nav().then(nav => nav.select('test-pages'))
		return result
	},

	allTests: function() {
		console.log('display: ui-tests/components/test-menu.hbs')
		appDisplay.display(testMenu())
	},

	colors: function() {
		appDisplay.display(new ColorsTestView())
	},

	viewIcons: function() {
		appDisplay.display(new ViewIconsView())
	},

	componentIconTest: function() {
		appDisplay.display(new ComponentIconTest())
	},

	buttons: function() {
		appDisplay.display(new Buttons())
	},

	toggles: function() {
		appDisplay.display(new Toggles())
	},

	inputs: function() {
		appDisplay.display(new Inputs())
	},

	panelsListsTables: function() {
		appDisplay.display(new PanelsListsTables())
	},

	trees: function() {
		appDisplay.display(new TreesView())
	},

	twoColumnExpand: function() {
		appDisplay.display(new TwoColumnExpandView())
	},

	progressIndicators: function() {
		appDisplay.display(new ProgressIndicatorsTestView())
	},

	textLinksBadges: function() {
		appDisplay.display(new TextLinksBadgesView())
	},

	calendars: function() {
		appDisplay.display(new CalendarsView())
	},

	tooltipsBanners: function() {
		appDisplay.display(new TooltipsBannersView())
	},

	loadingPage: function() {
		appDisplay.display(new LoadingPageView())
	},

	emptyState: function(view) {
		appDisplay.display(new EmptyStateView({
			view: view
		}))
	},

	dialog: function() {
		appDisplay.display(new DialogTest())
	},

	dashboardWidgets: function() {
		appDisplay.display(new DashboardWidgetsView())
	},

	miscComponents: function() {
		appDisplay.display(new MiscComponentsView())
	},

	reportDesignerTable: function() {
		appDisplay.display(reportDesignerTable())
	},

	conjunctionEditor: function() {
		appDisplay.display(new ConjunctionEditorExamplesView())
	},

	logician: function() {
		appDisplay.display(new LogicianExamplesView())
	},

	dashboardAIAssistant: function() {
		appDisplay.display(new DashboardAIAssistantTestView())
	},

	emptyReportTable: function() {
		appDisplay.display(emptyReportTable())
	}
})

export default TestRouter
